import { render, staticRenderFns } from "./TabFooter.vue?vue&type=template&id=3b640bef&scoped=true"
var script = {}
import style0 from "./TabFooter.vue?vue&type=style&index=0&id=3b640bef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b640bef",
  null
  
)

export default component.exports